import * as runtypes from 'runtypes';

export const Scroll = runtypes.Record({
  x: runtypes.Number,
  y: runtypes.Number
});

export type Scroll = runtypes.Static<typeof Scroll>;
